const SkeletonBlock = ({ className }: { className?: string }) => {
  return <div className={`animate-pulse rounded-md bg-muted ${className}`} />;
};

export const TicketDetailsSkeleton = () => {
  return (
    <div className="flex h-full flex-col p-4">
      {/* --- Header Skeleton --- */}
      <div className="mb-4 space-y-3 border-b pb-4">
        <SkeletonBlock className="h-8 w-3/4" />
        <SkeletonBlock className="h-4 w-1/2" />
        <div className="flex space-x-4 pt-2">
          <SkeletonBlock className="h-6 w-28" />
          <SkeletonBlock className="h-6 w-28" />
        </div>
      </div>

      {/* --- Tabs Skeleton --- */}
      <div className="grid w-full grid-cols-4 gap-2">
        <SkeletonBlock className="h-10" />
        <SkeletonBlock className="h-10" />
        <SkeletonBlock className="h-10" />
        <SkeletonBlock className="h-10" />
      </div>

      {/* --- Details Tab Content Skeleton --- */}
      <div className="flex-1 space-y-6 overflow-y-auto p-1 pt-6">
        <div className="space-y-2">
          <SkeletonBlock className="h-4 w-1/4" />
          <SkeletonBlock className="h-10 w-full" />
        </div>

        <div className="space-y-2">
          <SkeletonBlock className="h-4 w-1/3" />
          <SkeletonBlock className="h-10 w-full" />
        </div>

        <div className="space-y-2">
          <SkeletonBlock className="h-4 w-1/5" />
          <SkeletonBlock className="h-10 w-2/3" />
        </div>

        <div className="space-y-2">
          <SkeletonBlock className="h-4 w-1/4" />
          <SkeletonBlock className="h-10 w-full" />
        </div>
      </div>

      <div className="mt-4 border-t pt-4 dark:border-gray-600">
        <SkeletonBlock className="ml-auto h-10 w-32" />
      </div>
    </div>
  );
};
